import { useEffect, useState } from "react";
import Menu from "../Menubar/Menu";
import { Anlegen } from "./Anlegen";
import { Kontendetails } from "./Kontendetails";
import "./MeinCss.css";
import { Categories } from "../MainMenu/MenüSicht";
var MonitorApi = require("monitor-api");

export default function Kontenverwaltung ({ myApiClient, setSection }) {
    var zvInstance = new MonitorApi.ZweckverbandApi(myApiClient);
    var userInstance = new MonitorApi.LoginApi(myApiClient);
    const [whichTab, setWhichTab] = useState(1);
    // 1- neu anlegen, 2- einsehen
    // const changeTab = (index) => {
    //     setWhichTab(index);
    // }

    useEffect(() => {
        setSection('Kontenverwaltung');
      }, [setSection]);


    return (
        <div className="next-to-menu">
            <Menu />
            <Categories>
                <div className="tab-collection">
                    <button className={whichTab === 1 ? "tab tab-active" : "tab"} onClick={() => setWhichTab(1)}>&#43; neues Konto anlegen</button>
                    <button className={whichTab === 2 ? "tab tab-active" : "tab"} onClick={() => setWhichTab(2)}> &#127875; Kontendetails einsehen</button>
                </div>
                <div className="content">
                    {whichTab === 1 && <Anlegen zvInstance={zvInstance} userInstance={userInstance}/>}
                    {whichTab === 2 && <Kontendetails userInstance={userInstance} />}
                </div>
            </Categories>
            <div className="pika">
                <div className="pikachu" ></div>

            </div>
        </div>
    )
}